/** @format */

import { useTranslation } from "react-i18next";
import { trackEvent } from "../utils/analytics";

const FEEDBACK_FORM_URL = "https://wkf.ms/4vnjtwp";

export const FeedbackButton = () => {
	const { t } = useTranslation();

	return (
		<a
			href={FEEDBACK_FORM_URL}
			target="_blank"
			rel="noopener noreferrer"
			onClick={() => trackEvent("feedback_click", { location: "floating_button" })}
			aria-label={t("feedback.ariaLabel")}
			title={t("feedback.tooltip")}
			className="fixed bottom-10 left-5 z-50 flex items-center gap-2 rounded-full bg-(--public-color-theme-primary) px-4 py-3 text-sm font-semibold text-white shadow-lg transition-transform hover:scale-105 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--public-color-theme-primary)"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				className="h-5 w-5"
				aria-hidden="true"
			>
				<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
			</svg>
			<span className="hidden sm:inline">{t("feedback.label")}</span>
		</a>
	);
};
